import {Component} from 'react'
import {Route, Switch, Redirect} from 'react-router-dom'

import LoginForm from './components/LoginForm'
import SignUpForm from './components/SignUpForm'
import Home from './components/Home'
import Products from './components/Products'
import ProductItemDetails from './components/ProductItemDetails'
import Cart from './components/Cart'
import NotFound from './components/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import BackToTop from './components/BackToTop'
import ErrorBoundary from './components/ErrorBoundary'
import CartContext from './context/CartContext'
import {ToastProvider} from './context/ToastContext'
import {WishlistProvider} from './context/WishlistContext'
import {ThemeProvider} from './context/ThemeContext'

class App extends Component {
  state = {
    cartList: [],
  }

  removeAllCartItems = () => {
    this.setState({cartList: []})
  }

  incrementCartItemQuantity = id => {
    this.setState(prevState => ({
      cartList: prevState.cartList.map(eachItem => {
        if (eachItem.id === id) {
          return {...eachItem, quantity: eachItem.quantity + 1}
        }
        return eachItem
      }),
    }))
  }

  decrementCartItemQuantity = id => {
    this.setState(prevState => ({
      cartList: prevState.cartList.map(eachItem => {
        if (eachItem.id === id) {
          if (eachItem.quantity === 1) {
            this.removeCartItem(eachItem.id)
          }
          return {...eachItem, quantity: eachItem.quantity - 1}
        }
        return eachItem
      }),
    }))
  }

  removeCartItem = id => {
    this.setState(prevState => ({
      cartList: prevState.cartList.filter(eachItem => eachItem.id !== id),
    }))
  }

  addCartItem = product => {
    this.setState(prevState => {
      const existingItem = prevState.cartList.find(
        item => item.id === product.id,
      )
      if (existingItem) {
        return {
          cartList: prevState.cartList.map(item => {
            if (item.id === product.id) {
              return {...item, quantity: item.quantity + product.quantity}
            }
            return item
          }),
        }
      }
      return {cartList: [...prevState.cartList, {...product}]}
    })
  }

  render() {
    const {cartList} = this.state

    return (
      <ErrorBoundary>
        <ThemeProvider>
          <ToastProvider>
            <WishlistProvider>
              <CartContext.Provider
                value={{
                  cartList,
                  addCartItem: this.addCartItem,
                  removeCartItem: this.removeCartItem,
                  incrementCartItemQuantity: this.incrementCartItemQuantity,
                  decrementCartItemQuantity: this.decrementCartItemQuantity,
                  removeAllCartItems: this.removeAllCartItems,
                }}
              >
                <Switch>
                  <Route exact path="/login" component={LoginForm} />
                  <Route exact path="/signup" component={SignUpForm} />
                  <ProtectedRoute exact path="/" component={Home} />
                  <ProtectedRoute exact path="/products" component={Products} />
                  <ProtectedRoute
                    exact
                    path="/products/:id"
                    component={ProductItemDetails}
                  />
                  <ProtectedRoute exact path="/cart" component={Cart} />
                  <Route path="/not-found" component={NotFound} />
                  <Redirect to="not-found" />
                </Switch>
                <BackToTop />
              </CartContext.Provider>
            </WishlistProvider>
          </ToastProvider>
        </ThemeProvider>
      </ErrorBoundary>
    )
  }
}

export default App
